export default __webpack_public_path__ + "static/media/spotlight.794039a7.png";